<script>
export default {
  props: {
    xsmall: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      default: {
        size: 'medium',
        style: 'border',
        color: 'primary',
      },
    };
  },
  computed: {
    $_size() {
      if (this.medium || this.md) {
        return 'medium';
      }
      if (this.small || this.sm) {
        return 'small';
      }
      if (this.xsmall || this.xs) {
        return 'xsmall';
      }
      if (this.legoInput) {
        return this.legoInput.size;
      }
      return this.default.size;
    },
  },
};
</script>
